import React, { forwardRef, PureComponent } from 'react'
import DatePicker from 'react-datepicker'
import { withTheme } from 'styled-components'
import moment from 'moment'

import { ButtonReg } from 'atoms/Buttons'
import { FormSelect } from 'atoms/Inputs'
import { Label } from 'atoms/Texts'
import {
  MainWrapper,
  ModalHead,
  ModalFooter,
  LevelRowContainer,
  InputRow,
  BaseDatePickerInput,
  Input,
} from './styles'

export class RainfallModal extends PureComponent {
  render() {
    const { theme, rainfallData, isDisabled, fnChange, companiesList } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      arrowPos: 'calc(100% - 12px)',
      arrowSize: '16px'
    }

    const company = companiesList.find(c => c.id === rainfallData.companyId)

    const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
      <BaseDatePickerInput onClick={onClick} ref={ref}>
        {value}
      </BaseDatePickerInput>
    ))

    return (
      <MainWrapper>
        <ModalHead>
          <Label lineheight={'29px'} size={'24px'} mb={'0px'}>
            {rainfallData.hasOwnProperty('id') ? 'Edit ' : 'Add New '}
          </Label>
        </ModalHead>
        <LevelRowContainer>
          <InputRow>
            <Label lineheight={'14px'} size={'12px'}>
              Company
            </Label>
            <FormSelect
              placeholder={'Select Company'}
              onChangeVal={e => fnChange(+e.target.value, 'companyId')}
              options={companiesList}
              value={rainfallData.companyId}
              valField={'id'}
              dispField={'name'}
              {...inputConfig}
            />
            <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
              Contractor
            </Label>
            <FormSelect
              placeholder={'Select Contractor'}
              onChangeVal={e => fnChange(e.target.value, 'contractorId')}
              options={company ? company.contractors : []}
              value={rainfallData.contractorId}
              valField={'id'}
              dispField={'name'}
              {...inputConfig}
            />
            <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
              Pit
            </Label>
            <FormSelect
              placeholder={'Select Pit'}
              onChangeVal={e => fnChange(e.target.value, 'pitId')}
              options={company ? company.locations : []}
              value={rainfallData.pitId}
              valField={'id'}
              dispField={'name'}
              {...inputConfig}
            />
            <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
              Shift
            </Label>
            <FormSelect
              placeholder={'Select Shift'}
              onChangeVal={e => fnChange(e.target.value, 'shiftId')}
              options={company ? company.companyShifts : []}
              value={rainfallData.shiftId}
              valField={'id'}
              dispField={'name'}
              {...inputConfig}
            />

            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Date
                </Label>
                <div>
                  <DatePicker
                    selected={moment(rainfallData.date).toDate()}
                    onChange={date => fnChange(moment(date).format('YYYY-MM-DD'), 'date')}
                    dateFormat={'yyyy-MM-dd'}
                    customInput={<DatePickerInput />}
                  />
                </div>
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Amount
                </Label>
                <Input
                  type="number"
                  value={rainfallData.amount}
                  onChange={e => fnChange(e.target.value, 'amount')}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Rain From
                </Label>
                <div>
                  <DatePicker
                    selected={moment(rainfallData.rainFrom).toDate()}
                    onChange={date => fnChange(moment(date).format('YYYY/MM/DD HH:mm'), 'rainFrom')}
                    timeInputLabel="Time:"
                    dateFormat={'MM/dd/yyyy HH:mm'}
                    customInput={<DatePickerInput />}
                    showTimeInput
                  />
                </div>
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Rain To
                </Label>
                <div>
                  <DatePicker
                    selected={moment(rainfallData.rainTo).toDate()}
                    onChange={date => fnChange(moment(date).format('YYYY/MM/DD HH:mm'), 'rainTo')}
                    timeInputLabel="Time:"
                    dateFormat={'MM/dd/yyyy HH:mm'}
                    customInput={<DatePickerInput />}
                    showTimeInput
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Slippery From
                </Label>
                <div>
                  <DatePicker
                    selected={moment(rainfallData.slipperyFrom).toDate()}
                    onChange={date => fnChange(moment(date).format('YYYY/MM/DD HH:mm'), 'slipperyFrom')}
                    timeInputLabel="Time:"
                    dateFormat={'MM/dd/yyyy HH:mm'}
                    customInput={<DatePickerInput />}
                    showTimeInput
                  />
                </div>
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Slippery To
                </Label>
                <div>
                  <DatePicker
                    selected={moment(rainfallData.slipperyTo).toDate()}
                    onChange={date => fnChange(moment(date).format('YYYY/MM/DD HH:mm'), 'slipperyTo')}
                    timeInputLabel="Time:"
                    dateFormat={'MM/dd/yyyy HH:mm'}
                    customInput={<DatePickerInput />}
                    showTimeInput
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Total Rain
                </Label>
                <Input
                  type="number"
                  value={rainfallData.totalRain}
                  onChange={e => fnChange(e.target.value, 'totalRain')}
                />
              </div>
              <div className="col-6">
                <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
                  Total Slippery
                </Label>
                <Input
                  type="number"
                  value={rainfallData.totalSlippery}
                  onChange={e => fnChange(e.target.value, 'totalSlippery')}
                />
              </div>
            </div>

            <Label lineheight={'14px'} size={'12px'} mt={'16px'}>
              Remark
            </Label>
            <Input
              type="text"
              value={rainfallData.remark}
              onChange={e => fnChange(e.target.value, 'remark')}
            />
          </InputRow>
        </LevelRowContainer>

        <ModalFooter>
          <ButtonReg onClick={this.props.fnSwitch} disabled={isDisabled} transparent btnTxt={'Cancel'} />
          <ButtonReg onClick={this.props.fnSubmit} disabled={isDisabled} btnTxt={isDisabled ? 'Submitting...' : 'Submit'} />
        </ModalFooter>
      </MainWrapper>
    )
  }
}

export default withTheme(RainfallModal)
